"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactGtmModule = _interopRequireDefault(require("react-gtm-module"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var gtmUtil = {
  pushTagManager: function pushTagManager(userData, event) {
    var specificEventProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var dataLayerName = arguments.length > 3 ? arguments[3] : undefined;
    if (!userData) {
      return {
        error: 'No user provided'
      };
    }
    var userDetail = userData.userDetail,
      roleSelected = userData.roleSelected,
      _userData$nodeData = userData.nodeData,
      nodeData = _userData$nodeData === void 0 ? [] : _userData$nodeData;
    var tagManagerArgs = {
      dataLayer: _objectSpread({
        event: event,
        userId: userDetail.userId,
        tenantId: userDetail.tenantId,
        programId: userDetail.programId,
        userRole: roleSelected ? roleSelected.displayName : roleSelected,
        organizationNode: {
          organizationNodeLevelOne: nodeData.filter(function (o) {
            return o.levelIndex === 1;
          }).map(function (o) {
            return o.nodeName;
          }),
          organizationNodeLevelTwo: nodeData.filter(function (o) {
            return o.levelIndex === 2;
          }).map(function (o) {
            return o.nodeName;
          }),
          organizationNodeLevelThree: nodeData.filter(function (o) {
            return o.levelIndex === 3;
          }).map(function (o) {
            return o.nodeName;
          })
        },
        vibrentAccount: userDetail.vibrentUser
      }, specificEventProps),
      dataLayerName: dataLayerName
    };
    return _reactGtmModule.default.dataLayer(tagManagerArgs) ? 'success' : 'failure';
  },
  initTagManager: function initTagManager() {
    var initValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var initValuesChk = _objectSpread(_objectSpread({}, initValues), {}, {
      gtmId: initValues.gtmId || process.env.REACT_APP_GTM_ID || 'GTM-NPG4RF7' // required
    });

    _reactGtmModule.default.initialize(initValuesChk);
    return 'success';
  }
};
var _default = gtmUtil;
exports.default = _default;